import React from 'react'
import PropTypes from 'prop-types'
import {FaIcon} from '../components'

const DEFAULT_ICONS = {
  success: 'circle-check',
  warn: 'triangle-exclamation',
  error: 'circle-exclamation',
  info: 'circle-info',
}

export const GGAlert = ({
  message,
  variant = 'info',
  icon,
  className,
}) => {
  const resolvedIcon = icon === false ? null : (icon || DEFAULT_ICONS[variant])

  return (
    <div className={[ 'gg-alert', `gg-alert--${variant}`, className ].filter(Boolean).join(' ')} role="alert">
      {resolvedIcon && (
        <span className="gg-alert__icon">
          <FaIcon icon={resolvedIcon} style={{width: '14px', height: '14px'}}/>
        </span>
      )}
      <span className="gg-alert__message">{message}</span>
    </div>
  )
}

GGAlert.propTypes = {
  message: PropTypes.node.isRequired,
  variant: PropTypes.oneOf([ 'success', 'warn', 'error', 'info' ]),
  icon: PropTypes.oneOfType([ PropTypes.string, PropTypes.bool ]),
  className: PropTypes.string,
}
